function* $b8edfdf402ba7faa$var$iterateLevel(walker, inline = false) {
    do {
        const { currentNode: currentNode } = walker;
        if (currentNode.nodeType === Node.TEXT_NODE) {
            yield [
                'inline',
                currentNode
            ];
            continue;
        }
        // Inline can only be broken across text nodes
        const isInline = inline || window.getComputedStyle(currentNode).display.includes('inline');
        yield [
            isInline ? 'inline' : 'enter',
            currentNode
        ];
        if (window.getComputedStyle(currentNode).display === 'table-row') ;
        else if (!currentNode.matches('picture,video,canvas,object,audio,embed,iframe,svg,math') && walker.firstChild()) {
            yield* $b8edfdf402ba7faa$var$iterateLevel(walker, isInline);
            walker.parentNode();
        }
        if (!isInline) yield [
            'exit',
            currentNode
        ];
    }while (walker.nextSibling());
}
const $b8edfdf402ba7faa$var$types = NodeFilter.SHOW_ELEMENT + NodeFilter.SHOW_TEXT;
function* $b8edfdf402ba7faa$export$146769bef319e409(root, nodeFilter) {
    const walker = document.createTreeWalker(root, $b8edfdf402ba7faa$var$types, nodeFilter);
    if (!walker.nextNode()) return;
    yield* $b8edfdf402ba7faa$var$iterateLevel(walker);
}


class $dfb6e5ce33aff4a7$export$85f1a4080743d124 extends Map {
    get(node) {
        if (this.has(node)) return super.get(node);
        let rect;
        if (node.nodeType === Node.TEXT_NODE) {
            const range = new Range();
            range.selectNode(node);
            rect = range.getBoundingClientRect();
        } else rect = node.getBoundingClientRect();
        this.set(node, rect);
        return rect;
    }
    acceptNode(node) {
        const rect = this.get(node);
        if (rect.height === 0) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
    }
}


/**
 * Represents a possible break point
 *
 * The spec has three types of breakpoints:
 * - Class A: between siblings
 * - Class B: between line-boxes
 * - Class C: between a block and child content edges
 *
 * Only class A and B are supported
 */ class $eff1b8fdc8ada8f0$export$605fe2834acd8b3d {
    constructor({ rectFilter: rectFilter, nodeRules: nodeRules, root: root }){
        this.rectFilter = rectFilter;
        this.nodeRules = nodeRules;
        this.root = root;
        this.type = 'base';
    }
    // A forced breakpoint
    get force() {
        return false;
    }
    // Breakpoint is set to avoid
    get avoid() {
        return false;
    }
    // Breakpoint is overflowing content area
    get overflowing() {
        return this.root.scrollHeight > this.root.clientHeight;
    }
    // Return range of overflowing content
    range() {
        return null;
    }
    // Internals
    // ---------
    get rootRect() {
        return this.rectFilter.get(this.root);
    }
}



/**
 * Yields each line box as a range
 *
 * The selection API is the only API that gives any access to lineboxes
 *
 * Calculating though measuring ranges is slow and cannot cope
 * with different writing directions or unusual margins are paddings.
 */ function* $2a1c19376151cc13$export$a305012e00910036(nodes) {
    const selection = window.getSelection();
    const firstText = nodes.find((node)=>node.nodeType === Node.TEXT_NODE);
    const lastText = [
        ...nodes
    ].reverse().find((node)=>node.nodeType === Node.TEXT_NODE);
    if (!firstText) return;
    const textRange = new Range();
    textRange.setStart(firstText, 0);
    textRange.setEnd(lastText, lastText.data.length);
    selection.empty();
    selection.addRange(textRange);
    selection.collapseToStart();
    let lastRange = null;
    while(true){
        selection.modify('extend', 'forward', 'line');
        const lineRange = selection.getRangeAt(0);
        if (lastRange) lineRange.setStart(lastRange.endContainer, lastRange.endOffset);
        if (lineRange.collapsed) return;
        // Chrome gets stuck at full width inline blocks
        // So jump end to the start of the next text node
        if (lineRange.endOffset === 0 && lineRange.endContainer.nodeType === Node.ELEMENT_NODE) {
            const node = nodes.find((item)=>item.nodeType === Node.TEXT_NODE && item !== lineRange.endContainer && lineRange.comparePoint(item, 0) === 1);
            if (node) lineRange.setEndBefore(node);
        }
        if (textRange.compareBoundaryPoints(Range.END_TO_END, lineRange) === -1) lineRange.setEnd(textRange.endContainer, textRange.endOffset);
        // Stuck protection
        if (lastRange && lineRange.compareBoundaryPoints(Range.START_TO_START, lastRange) === 0) break;
        yield lineRange;
        // At end of the text range
        if (textRange.compareBoundaryPoints(Range.END_TO_END, lineRange) === 0) break;
        lastRange = lineRange.cloneRange();
    }
}


function $3694fd24b80d2a6e$var$getMeasurement(style, prop) {
    return parseFloat(style.getPropertyValue(prop)) || 0;
}
function $3694fd24b80d2a6e$var$collapseMargins(style) {
    return !$3694fd24b80d2a6e$var$getMeasurement(style, 'padding-bottom') && !$3694fd24b80d2a6e$var$getMeasurement(style, 'border-bottom-width') && !style.display.includes('inline') && style.overflow === 'visible' && style.float === 'none';
}
function $3694fd24b80d2a6e$var$collapsedMargins(margins) {
    return Math.max(0, Math.max(0, ...margins.filter((v)=>v >= 0)) + Math.min(0, ...margins.filter((v)=>v < 0)));
}
function $3694fd24b80d2a6e$export$1bc603050bd777b1(node, root, includeInner) {
    let bottom = 0;
    let cursor = node.parentNode;
    let style = node.nodeType === Node.ELEMENT_NODE ? window.getComputedStyle(node) : {
        getPropertyValue: ()=>0
    };
    let margins = [
        $3694fd24b80d2a6e$var$getMeasurement(style, 'margin-bottom')
    ];
    if (includeInner) {
        bottom += $3694fd24b80d2a6e$var$getMeasurement(style, 'padding-bottom');
        bottom += $3694fd24b80d2a6e$var$getMeasurement(style, 'border-bottom-width');
    }
    while(cursor && !cursor.contains(root)){
        style = window.getComputedStyle(cursor);
        if ($3694fd24b80d2a6e$var$collapseMargins(style)) margins.push($3694fd24b80d2a6e$var$getMeasurement(style, 'margin-bottom'));
        else {
            bottom += $3694fd24b80d2a6e$var$collapsedMargins(margins);
            margins = [
                $3694fd24b80d2a6e$var$getMeasurement(style, 'margin-bottom')
            ];
            bottom += $3694fd24b80d2a6e$var$getMeasurement(style, 'padding-bottom');
            bottom += $3694fd24b80d2a6e$var$getMeasurement(style, 'border-bottom-width');
        }
        cursor = cursor.parentNode;
    }
    bottom += $3694fd24b80d2a6e$var$collapsedMargins(margins);
    return bottom;
}


class $87aa489adb451438$export$1243915ec9076a18 extends (0, $eff1b8fdc8ada8f0$export$605fe2834acd8b3d) {
    constructor(...args){
        super(...args);
        this.nodes = [];
        this.type = 'inline';
    }
    get overflowing() {
        const rect = this.rectFilter.get(this.firstNode);
        return rect.top > this.rootRect.bottom;
    }
    range({ disableRules: disableRules = [], avoidDepth: avoidDepth = 0 } = {}) {
        const { widows: widows, orphans: orphans } = this.containerRules;
        if (widows === 0 && orphans === 0) return null;
        if (!(disableRules.includes(4) && this.containerRules.breakInsideAvoid <= avoidDepth) && this.containerRules.breakInsideAvoid) return null;
        const lineBoxRange = this.findLineBoxRange(disableRules.includes(3));
        const overflowingNodeRange = this.findFirstOverflowingNodeRange();
        let overflowing = lineBoxRange || overflowingNodeRange;
        if (lineBoxRange && overflowingNodeRange) {
            if (lineBoxRange.compareBoundaryPoints(Range.START_TO_START, overflowingNodeRange) === 1) overflowing = lineBoxRange;
            else overflowing = overflowingNodeRange;
        }
        if (!overflowing) return null;
        const range = new Range();
        range.setStart(overflowing.startContainer, overflowing.startOffset);
        range.setEndAfter(this.root.lastChild);
        return range;
    }
    // Internals
    // ---------
    // Find the first overflowing linebox obeying widow and orphan rules
    findLineBoxRange(relaxWidowsAndOrphans) {
        let { widows: widows, orphans: orphans } = this.containerRules;
        widows = widows || 2;
        orphans = orphans || 2;
        if (relaxWidowsAndOrphans) {
            widows = 1;
            orphans = 1;
        }
        let lineBoxes = [];
        let overflow = false;
        let overflowIndex;
        for (const lineBox of (0, $2a1c19376151cc13$export$a305012e00910036)(this.nodes)){
            if (!overflow) {
                const rect = lineBox.getBoundingClientRect();
                if (rect.bottom > this.rootRect.bottom - this.bottomSpace) {
                    overflow = lineBox;
                    overflowIndex = lineBoxes.length;
                }
            }
            if (overflow && lineBoxes.length > overflowIndex + widows - 1) break;
            lineBoxes.push(lineBox);
        }
        if (overflowIndex !== undefined) {
            if (overflowIndex < orphans) // Insufficient orphans
            return null;
            lineBoxes = lineBoxes.slice(orphans);
        }
        if (lineBoxes.length === 1) return null;
        return lineBoxes[lineBoxes.length - widows] || null;
    }
    // Find the first overflowing element
    // If it is not a text node, and not the first node return it
    findFirstOverflowingNodeRange() {
        const foundNode = this.nodes.find((node)=>{
            const rect = this.rectFilter.get(node);
            return rect.bottom > this.rootRect.bottom - (0, $3694fd24b80d2a6e$export$1bc603050bd777b1)(node, this.root);
        });
        if (!foundNode || foundNode.nodeType === Node.TEXT_NODE || foundNode === this.firstNode) return null;
        const range = new Range();
        range.setStartBefore(foundNode);
        return range;
    }
    get container() {
        if (this._container) return this._container;
        const range = new Range();
        range.setStartBefore(this.firstNode);
        range.setEndAfter(this.lastNode);
        let container = range.commonAncestorContainer;
        if (container.nodeType === Node.TEXT_NODE) container = container.parentNode;
        this._container = container;
        return container;
    }
    get bottomSpace() {
        return this._bottomSpace ??= (0, $3694fd24b80d2a6e$export$1bc603050bd777b1)(this.container, this.root, true);
    }
    get containerRules() {
        return this._containerRules ??= this.nodeRules.get(this.container);
    }
    get firstNode() {
        return this.nodes[0];
    }
    get lastNode() {
        return this.nodes[this.nodes.length - 1];
    }
}




class $faae309a5ad2def9$export$30ad6d223e92737e extends (0, $eff1b8fdc8ada8f0$export$605fe2834acd8b3d) {
    constructor(...args){
        super(...args);
        this.leadingNodes = [];
        this.trailingNodes = [];
    }
    get force() {
        return this._force ??= this.leadingNodes.some((node)=>this.nodeRules.get(node).breakBefore === 'page') || this.trailingNodes.some((node)=>this.nodeRules.get(node).breakAfter === 'page');
    }
    get overflowing() {
        return this.leadingNodes.some(this.hasLeadingOverflow, this) || this.trailingNodes.some(this.hasTrailingOverflow, this);
    }
    get avoid() {
        return this.leadingNodes.some((node)=>[
                'avoid',
                'avoid-page'
            ].includes(this.nodeRules.get(node).breakBefore)) || this.trailingNodes.some((node)=>[
                'avoid',
                'avoid-page'
            ].includes(this.nodeRules.get(node).breakAfter));
    }
    get bottom() {
        let bottom = 0;
        for (const node of this.trailingNodes){
            const nodeBottom = this.getBottom(node);
            if (nodeBottom < bottom) return bottom;
            bottom = nodeBottom;
        }
        return bottom;
    }
    range({ disableRules: disableRules = [], avoidDepth: avoidDepth = 0 } = {}) {
        const { node: node, force: force, avoid: avoid } = this;
        if (!node || node === Node.ELEMENT_NODE) return null;
        if (!force && this.nodeRules.get(node).breakInsideParentAvoid > avoidDepth) return null;
        if (!force && !disableRules.includes(1) && avoid) return null;
        const range = new Range();
        range.setStartAfter(node);
        range.setEndAfter(this.root.lastChild);
        return range;
    }
    // Internals
    // ---------
    get node() {
        return this.trailingNodes[0];
    }
    hasLeadingOverflow(node) {
        const rect = this.rectFilter.get(node);
        return rect.top > this.rootRect.bottom;
    }
    getBottom(node) {
        const rect = this.rectFilter.get(node);
        return Math.ceil(rect.bottom + (0, $3694fd24b80d2a6e$export$1bc603050bd777b1)(node, this.root));
    }
    hasTrailingOverflow(node) {
        return this.getBottom(node) > Math.floor(this.rootRect.bottom);
    }
}


class $735fa0306754b434$export$247bac8acfb1da33 extends Map {
    get(node) {
        if (node instanceof Text) return this.get(node.parentNode);
        if (!(node instanceof Element)) // TODO: Don't go higher than the page root
        return {
            breakInsideAvoid: 0,
            breakInsideParentAvoid: 0,
            breakAfter: 'auto',
            breakBefore: 'auto',
            orphans: 2,
            widows: 2
        };
        if (this.has(node)) return super.get(node);
        const rule = this.findInheritedRule(node);
        this.set(node, rule);
        return rule;
    }
    maxDepth() {
        return Math.max(...[
            ...this.values()
        ].map((r)=>r.breakInsideAvoid));
    }
    findInheritedRule(node) {
        const parentRule = this.get(node.parentNode);
        const styles = window.getComputedStyle(node);
        const breakInside = this.breakInside(node, styles);
        return {
            breakInsideAvoid: parentRule.breakInsideAvoid + (breakInside ? 1 : 0),
            breakInsideParentAvoid: parentRule.breakInsideAvoid,
            breakAfter: styles.getPropertyValue('break-after'),
            breakBefore: styles.getPropertyValue('break-before'),
            orphans: parseInt(styles.getPropertyValue('--orphans') || styles.getPropertyValue('orphans') || 2, 10),
            widows: parseInt(styles.getPropertyValue('--widows') || styles.getPropertyValue('widows') || 2, 10)
        };
    }
    breakInside(node, styles) {
        return [
            'avoid',
            'avoid-page'
        ].includes(styles.getPropertyValue('break-inside'));
    }
}


function* $a201a4f6796033dd$export$b2e24cbcf4dbd900(root) {
    const rectFilter = new (0, $dfb6e5ce33aff4a7$export$85f1a4080743d124)();
    // Fix for older versions of safari
    rectFilter.acceptNode = rectFilter.acceptNode.bind(rectFilter);
    const nodeIterator = (0, $b8edfdf402ba7faa$export$146769bef319e409)(root, rectFilter);
    const nodeRules = new (0, $735fa0306754b434$export$247bac8acfb1da33)();
    let currentBreakPoint = new (0, $faae309a5ad2def9$export$30ad6d223e92737e)({
        root: root,
        nodeRules: nodeRules,
        rectFilter: rectFilter
    });
    let lastType;
    for (const [type, node] of nodeIterator){
        switch(type){
            case 'enter':
                if (lastType === 'inline') {
                    const lastBreakPoint = currentBreakPoint;
                    yield currentBreakPoint;
                    currentBreakPoint = new (0, $faae309a5ad2def9$export$30ad6d223e92737e)({
                        root: root,
                        nodeRules: nodeRules,
                        rectFilter: rectFilter
                    });
                    currentBreakPoint.trailingNodes.unshift(lastBreakPoint.lastNode);
                }
                currentBreakPoint.leadingNodes.push(node);
                break;
            case 'inline':
                if (lastType === 'exit') currentBreakPoint.leadingNodes.push(node);
                if (lastType !== type) {
                    yield currentBreakPoint;
                    currentBreakPoint = new (0, $87aa489adb451438$export$1243915ec9076a18)({
                        root: root,
                        nodeRules: nodeRules,
                        rectFilter: rectFilter
                    });
                }
                currentBreakPoint.nodes.push(node);
                break;
            case 'exit':
                if (lastType !== type) {
                    yield currentBreakPoint;
                    currentBreakPoint = new (0, $faae309a5ad2def9$export$30ad6d223e92737e)({
                        root: root,
                        nodeRules: nodeRules,
                        rectFilter: rectFilter
                    });
                }
                currentBreakPoint.trailingNodes.unshift(node);
                break;
            default:
                throw new Error(`unexpected node type ${type}`);
        }
        lastType = type;
    }
    yield currentBreakPoint;
    // If the last node is a text node and we are overflowing we may need to force a breakpoint
    yield new (0, $eff1b8fdc8ada8f0$export$605fe2834acd8b3d)({
        root: root,
        nodeRules: nodeRules,
        rectFilter: rectFilter
    });
}


function* $ee885449d48a1404$var$depths(breakPoints) {
    // The node rules are the same cached instance on every breakpoint
    const max = breakPoints[0].nodeRules.maxDepth();
    for(let i = 0; i <= max; i += 1)yield i;
}
function* $ee885449d48a1404$export$3c317435dc60a9cb(breakPoints) {
    // No rule disabling
    yield {
        disableRules: []
    };
    yield {
        disableRules: [
            3
        ]
    };
    for (const avoidDepth of $ee885449d48a1404$var$depths(breakPoints)){
        yield {
            disableRules: [
                3
            ],
            avoidDepth: avoidDepth
        };
        // Also relax break-before and break-after
        // While progressively relaxing more avoid rules
        yield {
            disableRules: [
                1,
                3
            ],
            avoidDepth: avoidDepth
        };
        // Also relax break-inside on line boxes
        yield {
            disableRules: [
                1,
                3,
                4
            ],
            avoidDepth: avoidDepth
        };
    }
}


function $fe49902f9d8ccf83$export$313dd01e7845f064(root) {
    const breakPointIterator = (0, $a201a4f6796033dd$export$b2e24cbcf4dbd900)(root);
    const breakPoints = [];
    let overflowing = false;
    for (const breakPoint of breakPointIterator){
        // Always use the first forced breakpoint
        if (!overflowing && breakPoint.force && !breakPoint.overflowing) {
            const range = breakPoint.range();
            if (range) return range;
        }
        if (!overflowing && breakPoint.overflowing) {
            overflowing = true;
            // Find the last useable breakpoint
            // Retrying with relaxed rules
            // https://www.w3.org/TR/css-break-3/#unforced-breaks
            for (const disableRules of (0, $ee885449d48a1404$export$3c317435dc60a9cb)(breakPoints))for (const previousBreakPoint of breakPoints){
                const range = previousBreakPoint.range(disableRules);
                if (range) return range;
            }
        }
        if (!overflowing) breakPoints.unshift(breakPoint);
        else {
            // No valid break point found.  We are overflowing
            // Use the next break point with any result
            const range = breakPoint.range({
                disableRules: [
                    1,
                    3,
                    4
                ],
                avoidDepth: Infinity
            });
            if (range) return range;
        }
    }
    return null;
}


const $9de7e7abba1056fb$var$rNamedSize = /^(A5|A4|A3|B5|B4|JIS-B5|JIS-B4|letter|legal|ledger|landscape|portrait)(?:\s+(landscape|portrait)$)?/i;
const $9de7e7abba1056fb$var$SIZES = {
    a5: [
        '148mm',
        '210mm'
    ],
    a4: [
        '210mm',
        '297mm'
    ],
    a3: [
        '297mm',
        '420mm'
    ],
    b5: [
        '176mm',
        '250mm'
    ],
    b4: [
        '250mm',
        '353mm'
    ],
    'jis-b5': [
        '182mm',
        '257mm'
    ],
    'jis-b4': [
        '257mm',
        '364mm'
    ],
    letter: [
        '8.5in',
        '11in'
    ],
    legal: [
        '8.5in',
        '14in'
    ],
    ledger: [
        '11in',
        '17in'
    ]
};
function $9de7e7abba1056fb$export$c3fe24b58b951a74(size) {
    size = size.trim().toLowerCase(); // eslint-disable-line no-param-reassign
    if (!size || size === 'auto') return $9de7e7abba1056fb$var$SIZES.a4;
    const match = $9de7e7abba1056fb$var$rNamedSize.exec(size);
    if (!match) {
        const parts = size.split(/\s+/);
        if (parts.length === 1) parts.push(parts[0]);
        return parts;
    }
    let [, namedSize, orientation] = match;
    if ([
        'portrait',
        'landscape'
    ].includes(namedSize)) {
        orientation = namedSize;
        namedSize = 'a4';
    }
    const matchedSize = [
        ...$9de7e7abba1056fb$var$SIZES[namedSize]
    ];
    if (orientation === 'landscape') matchedSize.reverse();
    return matchedSize;
}


function $6d273f825332b49d$export$31b40729666a4ae0() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}


function $6e057cb0373e0a0b$var$fixTable(table) {
    // If the table already has cols, don't add new ones
    if (!table.querySelector('col')) {
        const columns = [
            ...table.rows[0].cells
        ].reduce((total, cell)=>total + cell.colSpan, 0);
        for(let i = 0; i < columns; i += 1){
            const col = document.createElement('col');
            col.dataset.fragmenationCol = true;
            table.prepend(col);
        }
    }
    // Fix the widths of the columns
    [
        ...table.querySelectorAll('col')
    ].forEach((col)=>{
        const { width: width } = col.getBoundingClientRect();
        if (width) col.style.width = `${Math.ceil(width)}px`;
    });
}
function $6e057cb0373e0a0b$var$findAndMarkTables(range) {
    const tables = [];
    let cursor = range.startContainer;
    if (cursor.nodeType === Node.TEXT_NODE) cursor = cursor.parentNode;
    cursor = cursor.closest('table');
    while(cursor){
        cursor.dataset.fragmentationUuid = (0, $6d273f825332b49d$export$31b40729666a4ae0)();
        $6e057cb0373e0a0b$var$fixTable(cursor);
        tables.push(cursor);
        cursor = cursor.parentNode.closest('table');
    }
    return tables;
}
class $6e057cb0373e0a0b$export$3f0ee2fb7540ee15 {
    before(range) {
        this.tables = $6e057cb0373e0a0b$var$findAndMarkTables(range);
    }
    after(fragment) {
        this.tables.forEach((table)=>{
            const newTable = fragment.querySelector(`table[data-fragmentation-uuid="${table.dataset.fragmentationUuid}"]`);
            if (!newTable) return;
            // Remove fixed widths
            [
                ...table.querySelectorAll('col[data-fragmentation-col]')
            ].forEach((col)=>col.remove());
            // Add in thead
            if (!newTable.tHead && table.tHead) newTable.tHead = table.tHead.cloneNode(true);
            // Remove duplicated uuid
            delete newTable.dataset.fragmentationUuid;
        });
    }
}



function $2c3fecc8d739938a$var$visibleListItem(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    return node.matches('li') && node.getBoundingClientRect().height > 0;
}
function $2c3fecc8d739938a$var$findAndMarkLists(range) {
    const lists = [];
    let cursor = range.startContainer;
    if (cursor.nodeType === Node.TEXT_NODE) cursor = cursor.parentNode;
    cursor = cursor.closest('ol');
    while(cursor){
        cursor.dataset.fragmentationUuid = (0, $6d273f825332b49d$export$31b40729666a4ae0)();
        lists.push(cursor);
        if (cursor.reversed) {
            const items = [
                ...cursor.childNodes
            ].filter($2c3fecc8d739938a$var$visibleListItem).length;
            cursor.start = items;
        }
        cursor = cursor.parentNode.closest('ol');
    }
    return lists;
}
class $2c3fecc8d739938a$export$d310e656d02ceb96 {
    before(range) {
        this.lists = $2c3fecc8d739938a$var$findAndMarkLists(range);
    }
    after(fragment) {
        this.lists.forEach((list)=>{
            const items = [
                ...list.childNodes
            ].filter($2c3fecc8d739938a$var$visibleListItem).length;
            const newList = fragment.querySelector(`ol[data-fragmentation-uuid="${list.dataset.fragmentationUuid}"]`);
            if (newList) {
                if (newList.reversed) newList.start = list.start - items;
                else newList.start = list.start + items;
                delete newList.dataset.fragmentationUuid;
            }
        });
    }
}


class $7d63c063614ff29c$export$9103e258b982dbff {
    before(range) {
        const { startContainer: startContainer } = range;
        if (startContainer.nodeType === Node.ELEMENT_NODE && startContainer.matches('.page-content')) // Range is not inside an element
        return;
        let node = startContainer;
        if (node.nodeType === Node.TEXT_NODE) node = node.parentNode;
        while(node && !node.matches('.page-content')){
            node.dataset.fragmentedStart = 'true';
            node = node.parentNode;
        }
    }
    after(fragment) {
        fragment.querySelectorAll('[data-fragmented-start=true]').forEach((node)=>{
            delete node.dataset.fragmentedStart;
            node.dataset.fragmentedEnd = 'true';
        });
    }
}


function $7fca02a30a792c06$export$f9380c9a627682d3(range) {
    const extractors = [
        new (0, $6e057cb0373e0a0b$export$3f0ee2fb7540ee15)(),
        new (0, $2c3fecc8d739938a$export$d310e656d02ceb96)(),
        new (0, $7d63c063614ff29c$export$9103e258b982dbff)()
    ];
    extractors.forEach((extractor)=>extractor.before(range));
    const contents = range.extractContents();
    extractors.forEach((extractor)=>extractor.after(contents));
    return contents;
}


function $240c5cb84f2d9597$var$newPage({ footer: footer, header: header, pageNumber: pageNumber }) {
    const page = document.createElement('div');
    page.classList.add('page');
    page.setAttribute('role', 'region');
    page.setAttribute('aria-label', `Page ${pageNumber}`);
    page.setAttribute('data-page-number', pageNumber);
    page.style.setProperty('--page-number', pageNumber);
    document.body.appendChild(page);
    const pageInner = document.createElement('div');
    pageInner.classList.add('page-inner');
    page.appendChild(pageInner);
    if (header) {
        const pageHeader = document.createElement('div');
        pageHeader.classList.add('page-header');
        pageInner.appendChild(pageHeader);
        pageHeader.appendChild(header.cloneNode(true));
    }
    const pageContent = document.createElement('div');
    pageContent.classList.add('page-content');
    pageInner.appendChild(pageContent);
    if (footer) {
        const pageFooter = document.createElement('div');
        pageFooter.classList.add('page-footer');
        pageInner.appendChild(pageFooter);
        pageFooter.appendChild(footer.cloneNode(true));
    }
    return pageContent;
}
function $240c5cb84f2d9597$var$childrenToFragment(node) {
    const fragment = document.createDocumentFragment();
    Array.from(node.childNodes).forEach((child)=>{
        fragment.appendChild(child);
    });
    return fragment;
}
function $240c5cb84f2d9597$var$getStartingContent() {
    const main = document.querySelector('body > main');
    const content = $240c5cb84f2d9597$var$childrenToFragment(main || document.body);
    main?.remove();
    return content;
}
function $240c5cb84f2d9597$var$extractSelector(selector) {
    const node = document.querySelector(selector);
    if (node) return $240c5cb84f2d9597$var$childrenToFragment(node);
    return null;
}
function $240c5cb84f2d9597$var$emptyFragment(node) {
    return !node.hasChildNodes() || node.childNodes.length === 1 && node.firstChild.nodeType === Node.TEXT_NODE && !node.firstChild.data.trim();
}
function $240c5cb84f2d9597$var$emptyRange(range) {
    if (!range || range.collapsed || $240c5cb84f2d9597$var$emptyFragment(range.cloneContents())) return true;
    return false;
}
function $240c5cb84f2d9597$export$e9562cbc2a9880a8() {
    const size = (0, $9de7e7abba1056fb$export$c3fe24b58b951a74)(window.getComputedStyle(document.body).getPropertyValue('--page-size'));
    document.documentElement.style.setProperty('--page-width', size[0]);
    document.documentElement.style.setProperty('--page-height', size[1]);
    const header = $240c5cb84f2d9597$var$extractSelector('body > header');
    const footer = $240c5cb84f2d9597$var$extractSelector('body > footer');
    let content = $240c5cb84f2d9597$var$getStartingContent();
    document.body.innerHTML = '';
    let pageCount = 0;
    let forceExtraPage = false;
    while(forceExtraPage || !pageCount || content && !$240c5cb84f2d9597$var$emptyFragment(content)){
        pageCount += 1;
        const page = $240c5cb84f2d9597$var$newPage({
            footer: footer,
            header: header,
            pageNumber: pageCount
        });
        if (content) page.appendChild(content);
        const outerPage = page.closest('.page');
        outerPage.dispatchEvent(new CustomEvent('create-page', {
            bubbles: true
        }));
        let range = (0, $fe49902f9d8ccf83$export$313dd01e7845f064)(page);
        if ($240c5cb84f2d9597$var$emptyRange(range)) {
            // Last page
            outerPage.dataset.lastPage = 'true';
            // Recalculate overflow
            range = (0, $fe49902f9d8ccf83$export$313dd01e7845f064)(page);
            if (forceExtraPage) break;
            // Adding lastPage has created additional overflow
            // Need to force an extra page for headers and footers
            if (!$240c5cb84f2d9597$var$emptyRange(range)) {
                delete outerPage.dataset.lastPage;
                forceExtraPage = true;
                range = (0, $fe49902f9d8ccf83$export$313dd01e7845f064)(page);
            }
        }
        if (range) {
            outerPage.dispatchEvent(new CustomEvent('before-fragmentation', {
                detail: range,
                bubbles: true
            }));
            content = (0, $7fca02a30a792c06$export$f9380c9a627682d3)(range);
            outerPage.dispatchEvent(new CustomEvent('after-fragmentation', {
                detail: content,
                bubbles: true
            }));
        } else content = null;
    }
    document.body.style.setProperty('--page-count', pageCount);
    document.body.dataset.pageCount = pageCount;
    document.body.dispatchEvent(new CustomEvent('fragmentation-finished', {
        bubbles: true
    }));
}


window.addEventListener('DOMContentLoaded', async ()=>{
    document.body.setAttribute('aria-busy', 'true');
});
// Wait for everything to load
window.addEventListener('load', async ()=>{
    // Fonts aren't included in load 🤷
    await document.fonts.ready;
    // Fragment the pages
    (0, $240c5cb84f2d9597$export$e9562cbc2a9880a8)();
    document.body.setAttribute('aria-busy', 'false');
    // Line boxes are found using the selection api
    // Clear any selection and return to top
    window.getSelection().empty();
    window.scrollTo(0, 0);
});


//# sourceMappingURL=the_machine_stops.342b76a3.js.map
